<template>
    <div class="bg-white px-2 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
        <div class="flex-1 flex justify-between sm:hidden">
            <a href="#"
               @click.prevent="$emit('pageChange', currentPage > 1 ? currentPage - 1 : 1)"
               :class="`relative inline-flex items-center px-4 py-2 border text-sm font-medium rounded-md bg-white ${currentPage > 1 ? 'border-gray-300 text-gray-700 hover:bg-gray-50' : 'border-gray-100 text-gray-100'}`"
               :style="currentPage > 1 ? '' : 'pointer-events: none;'"
            > Poprzednia </a>
            <a href="#"
               @click.prevent="$emit('pageChange', currentPage < lastPage ? currentPage + 1 : lastPage)"
               :class="`ml-3 relative inline-flex items-center px-4 py-2 border text-sm font-medium rounded-md bg-white ${currentPage < lastPage ? 'border-gray-300 text-gray-700 hover:bg-gray-50' : 'border-gray-100 text-gray-100'}`"
               :style="currentPage < lastPage ? '' : 'pointer-events: none;'"> Następna </a>
        </div>

        <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">

            <div>
                <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                    <a href="#" v-if="currentPage > 1" @click.prevent="$emit('pageChange', currentPage - 1)"
                       class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                        <span class="sr-only">Poprzednia</span>
                        <ChevronLeftIcon class="h-5 w-5" aria-hidden="true"/>
                    </a>
                    <a v-for="page in lastPage" :key="page"
                       href="#"
                       @click.prevent="$emit('pageChange', page)"
                       :aria-current="page === currentPage ? 'page' : null"
                       class="pagination"
                       :class="page === currentPage ? 'current-page' : ((page > currentPage + 2 || page < currentPage-2) && page !== currentPage && page !== lastPage ? 'hidden-page' : 'page')">
                        {{ page }} </a>

                    <a href="#" v-if="currentPage < lastPage" @click.prevent="$emit('pageChange', currentPage + 1)"
                       class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                        <span class="sr-only">Następna</span>
                        <ChevronRightIcon class="h-5 w-5" aria-hidden="true"/>
                    </a>
                </nav>
            </div>

            <div class="flex justify-center">
                <p class="text-sm text-gray-700 m-2">
                    <span class="font-medium"> {{ fromItem }} </span>-<span class="font-medium"> {{ toItem }} </span>
                    <span> z {{ total }} wyników</span>
                </p>
            </div>

        </div>



    </div>



</template>

<script>
import {ChevronLeftIcon, ChevronRightIcon} from '@heroicons/vue/solid'

export default {
    components: {
        ChevronLeftIcon,
        ChevronRightIcon,
    },
    props: {
        currentPage: Number,
        total: Number,
        perPage: Number,
        lastPage: Number
    },
    computed: {
        fromItem() {
            return this.perPage * (this.currentPage - 1) + 1;
        },
        toItem() {
            return this.perPage * this.currentPage;
        },
    },
}
</script>
